import React from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./components";
import { ThemeProvider, createTheme } from "@mui/material";
import MusicContextProvider from "context/MusicPlayerProvider";

const theme = createTheme({
  typography: {
    allVariants: {
      fontFamily: "Lato",
    },
  },
});

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <MusicContextProvider>
          <AppRoutes />
        </MusicContextProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
